/**** cat.DevMNTType */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'DevMNTType',
  title: "Типы МНТ",
  elemsOnPage: 100,
  apiType: apiTypes.DEFAULT,
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px'
    },
    {
      name: 'name',
      title: 'Наименование',
      type: 'text',
      required: true,
      validate: (value: any) => /^[A-Za-z-А-Яа-я-0-9_-]+$/.test(value),
      validateError: 'Допустимы только буквы, цифры и знаки "_" и "-"',
      width: '30%'
    },
    {
      name: 'type',
      title: 'Код типа МНТ',
      type: 'text',
      required: true,
      validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
      validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
      width: '30%'
    },
    {
      name: 'version',
      title: 'Версия',
      type: 'text',
      required: true,
      //validate: (value: any) => /^[A-Za-z-0-9_-]+$/.test(value),
      //validateError: 'Допустимы только буквы латинского алфавита, цифры и знаки "_" и "-"',
      width: '30%'
    },
    {
      name: 'is_serial_number',
      title: 'Серийный номер',
      type: 'boolean',
      required: false,
      width: '205px',
    }
  ],
  newTemplate: {
    id: null,
    name: '',
    type: '',
    version: '',
    is_serial_number: false
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc'
  },
  import: {
    header: [
      {
        title: 'model_id',
        field: 'id',
      },
      {
        title: 'model_name',
        field: 'name',
      },
      {
        title: 'software_type',
        field: 'type',
      },
      {
        title: 'software_version',
        field: 'version',
      }
    ],
    example: `1;MNT;mnt;2_0`,
  },
  export: {
    fields: [
      {
        name: 'name',
        title: 'Наименование',
      },
      {
        name: 'type',
        title: 'Код типа МНТ',
      },
      {
        name: 'version',
        title: 'Версия',
      },
      {
        name: 'is_serial_number',
        title: 'Серийный номер',
        defaultValue: 'нет',
        format: {
          fields: ['is_serial_number'],
          template: '%1',
          values: {
            'true': 'да',
            'false': 'нет',
          },
        },
      },
    ],
  },
};

export default config;
